import { sm4 } from 'sm-crypto';
import CryptoJS from 'crypto-js';
/**
 * 1. 对应后端的 generateSm4KeyFromToken 逻辑
 * 核心：通过 Token 和 Salt 实时计算出 16 字节的 SM4 密钥 (返回 Hex 字符串)
 */
function deriveSm4Key(token, salt) {
  let keyName = 'secretKey' + token + salt
  if (sessionStorage.getItem(keyName)) {
    return sessionStorage.getItem(keyName)
  }
  const KDF_ITERATIONS = 10000; // 迭代次数必须与后端 10000 次完全一致
  const KEY_SIZE_BITS = 128;    // 128位密钥 = 16字节
  // CryptoJS 的 keySize 单位是 Word (4字节)，所以 128 / 32 = 4
  const keyWordArray = CryptoJS.PBKDF2(token, CryptoJS.enc.Utf8.parse(salt), {
    keySize: KEY_SIZE_BITS / 32,
    iterations: KDF_ITERATIONS,
    hasher: CryptoJS.algo.SHA256 // 对齐后端的 HmacSHA256
  });

  // 将算出的字节转换为 sm-crypto 认识的 Hex 字符串
  let key = CryptoJS.enc.Hex.stringify(keyWordArray)
  removeByPrefix('secretKey')
  sessionStorage.setItem(keyName, key)
  return key;
}
function removeByPrefix(prefix) {
  const keys = Object.keys(sessionStorage)
  keys.forEach(key => {
    if (key.startsWith(prefix)) {
      sessionStorage.removeItem(key)
    }
  })
}
/**
 * 2. 对应后端的 deriveRealIv 逻辑
 * 核心：将响应头的原始 Base64 IV 经 SHA-256 哈希后截取前 16 字节
 */
function deriveRealIv(ivBase64) {
  // 将 Base64 的原始 IV 解析为 WordArray
  const rootIvWordArray = CryptoJS.enc.Base64.parse(ivBase64);
  // 执行 SHA-256
  const sha256Hash = CryptoJS.SHA256(rootIvWordArray);
  // 截取前 16 字节（即前 4 个 Word），构造新的 WordArray
  const realIvWordArray = CryptoJS.lib.WordArray.create(sha256Hash.words.slice(0, 4), 16);

  return CryptoJS.enc.Hex.stringify(realIvWordArray);
}

/**
 * 3. 统一解密核心导出方法
 * @param {string} cipherTextBase64 后端返回的加密密文 (Base64)
 * @param {string} ivBase64         后端响应头带回的 X-SM4-IV (Base64)
 * @param {string} token            用户的 Token 字符串
 * @param {string} salt             用户对应的 Salt 盐值字符串
 */
// 移除 PKCS7 填充
function removePkcs7Padding(buffer) {
  const len = buffer.length;
  if (len === 0) return buffer;
  const padLen = buffer[len - 1];
  if (padLen < 1 || padLen > 16) return buffer;
  for (let i = len - padLen; i < len; i++) {
    if (buffer[i] !== padLen) return buffer;
  }
  return buffer.slice(0, len - padLen);
}
// 解密核心方法
export function decryptSm4CbcWithToken(cipherTextBase64, ivBase64, token, salt) {
  try {
    if (!cipherTextBase64 || !ivBase64 || !token || !salt) {
      return cipherTextBase64;
    }

    // 步骤 A: 实时计算密钥的字节（转成 Hex）
    const keyHex = deriveSm4Key(token, salt);

    // 步骤 B: 实时派生真实的 IV（转成 Hex）
    const realIvHex = deriveRealIv(ivBase64);

    // 步骤 C: 将 Base64 密文转为 Hex
    const cipherTextHex = CryptoJS.enc.Base64.parse(cipherTextBase64).toString(CryptoJS.enc.Hex);

    // 步骤 D: 调用 sm-crypto 核心解密
    const decryptedHex = sm4.decrypt(cipherTextHex, keyHex, {
      mode: 'cbc',
      iv: realIvHex,
      padding: 'pkcs7', // 对齐后端的 PKCS7Padding
      input: 'hex',      // 密文输入格式：hex / base64，和加密输出对应
      output: 'array'   // 直接输出 UTF-8 字符串
    });
    const uint8Bytes = new Uint8Array(decryptedHex);
    const cleanBytes = removePkcs7Padding(uint8Bytes);
    const plainText = new TextDecoder('utf-8').decode(cleanBytes);
    return JSON.parse(plainText)

  } catch (error) {
    console.error('SM4 实时计算解密失败，返回原数据:', error);
    return cipherTextBase64;
  }
}